import { Component, Input, OnDestroy, Optional } from '@angular/core';
import { IconComponent, TypographyComponent } from 'components';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ReportLanguageService } from '../../../../services/report-language.service';
import { reportMessage } from '../../../../services/report-messages';

@Component({
	standalone: true,
	selector: 'app-slide-no-data',
	imports: [IconComponent, TypographyComponent],
	template: `
		<div class="slide-no-data">
			<app-icon type="svg" class="slide-no-data__icon" [size]="64">
				no_data_slide
			</app-icon>
			<typography variant="p/sm_regular" class="slide-no-data__text">
				{{ message || defaultMessage }}
			</typography>
		</div>
	`,
	styles: [
		`
			:host {
				display: flex;
				flex: 1;

				.slide-no-data {
					flex: 1;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					gap: 16px;
					padding: 40px 0;

					.slide-no-data__icon {
						color: #d0d0d0;
					}

					.slide-no-data__text {
						display: block;
						// A reason is a sentence or two, not a caption: keep
						// it to a readable measure and centred under the icon.
						max-width: 560px;
						color: #adadad;
						text-align: center;
					}
				}
			}
		`
	]
})
export class SlideNoDataComponent implements OnDestroy {
	/**
	 * Why there is nothing to draw, when the slide knows. Without one it says
	 * the generic thing it always has, in the report's language.
	 */
	@Input() message: string | null = null;

	defaultMessage = reportMessage(null, 'empty.no_data');

	private unsubscriber = new Subject<void>();

	constructor(@Optional() reportLanguage: ReportLanguageService | null) {
		reportLanguage?.language$
			.pipe(takeUntil(this.unsubscriber))
			.subscribe(language => {
				this.defaultMessage = reportMessage(language, 'empty.no_data');
			});
	}

	ngOnDestroy(): void {
		this.unsubscriber.next();
		this.unsubscriber.complete();
	}
}
